<template>
  <PhoneInfo v-if="isMobile" id="app"/>
  <div id="app" v-else>
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import PhoneInfo from "./components/PhoneInfo/PhoneInfo"

export default {
  name: 'app',
  data() {
    return {
      isMobile: false
    };
  },
  beforeMount(){
    window.innerWidth < window.innerHeight ? this.isMobile = true : this.isMobile = false

    window.addEventListener("resize", () => {
      window.innerWidth < window.innerHeight ? this.isMobile = true : this.isMobile = false
    })
  },
  components: {
    PhoneInfo
  }
}
</script>

<style>
body{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
}
</style>
